// Electrical question visibility rules
//
// Follow-up questions only appear when at least one of the specified
// services is currently selected in `electrical_services`.

/**
 * @param {Object} question  A question from ELECTRICAL_QUESTIONS
 * @param {Object} answers   Current wizard answers
 * @returns {boolean}
 */
export const shouldShowQuestion = (question, answers) => {
  if (question.showIfAnyService) {
    const selectedServices = answers.electrical_services || [];
    const hasMatchingService = question.showIfAnyService.some((svc) =>
      selectedServices.includes(svc)
    );
    if (!hasMatchingService) return false;
  }
  return true;
};

export default shouldShowQuestion;
